import React from "react";
import preqinIcon from "../../icons/preqin.svg";
import "../styles/banner-header.css";
const iconMap = { preqin: preqinIcon };
export const computeBannerConfig = (params, gridContext) => {
    const directParams = {
        imageAlt: params.imageAlt,
        imageHeight: params.imageHeight,
        imageSrc: params.imageSrc,
        showSeparator: params.showSeparator,
        title: params.title,
        underline: params.underline,
        underlineColor: params.underlineColor,
        underlineHeight: params.underlineHeight
    };
    const nestedParams = params.headerGroupComponentParams || {};
    const contextBanner = gridContext?.bannerHeader || params.context?.bannerHeader || {};
    const bannerBase = { ...contextBanner, ...nestedParams };
    const banner = { ...bannerBase };
    Object.entries(directParams).forEach(([k, v]) => {
        if (v !== undefined && v !== null) {
            banner[k] = v;
        }
    });
    return banner;
};
export const BannerHeaderGroup = (params) => {
    const { api } = params;
    const gridContext = api?.getGridOption ? api.getGridOption("context") : params.context;
    const banner = computeBannerConfig(params, gridContext);
    const { title, imageSrc, imageAlt, showSeparator, underline, underlineColor, underlineHeight, imageHeight } = banner;
    const resolvedImage = imageSrc && iconMap[imageSrc] ? iconMap[imageSrc] : imageSrc;
    const classes = ["ins-grid-banner-header", underline ? "ins-grid-banner-header--underline" : ""].filter(Boolean).join(" ");
    const style = underline
        ? {
            "--banner-underline-color": underlineColor || "#dcdcdc",
            "--banner-underline-height": underlineHeight ? `${underlineHeight}px` : "2px"
        }
        : undefined;
    return (React.createElement("div", { className: classes, style: style, role: "presentation" },
        resolvedImage && React.createElement("img", { src: resolvedImage, alt: imageAlt || title || "banner", className: "ins-grid-banner-header__logo", style: imageHeight ? { "--banner-logo-height": `${imageHeight}px` } : undefined }),
        title && React.createElement("span", { className: "ins-grid-banner-header__title" }, title),
        showSeparator && React.createElement("span", { className: "ins-grid-banner-header__separator" })));
};
export default BannerHeaderGroup;
